import React from 'react'
import PropTypes from 'prop-types'
import LoginIcon from 'components/IconAntDesign/LoginIcon'
import { ACTION_BUTTON_CLASSES, INSURANCE_MENU_CLASSES } from 'templates/Button/actionButtonClasses'

const MobileNavigationAction = ({ as: Link = 'a', variant, children, className, ...props }) => (
  <Link {...props} className={[
    '!font-base',
    variant === 'insurance' ? INSURANCE_MENU_CLASSES : `${ACTION_BUTTON_CLASSES} w-full gap-xs border border-solid border-accent bg-accent !text-white shadow-card hover:brightness-95`,
    className,
  ].filter(Boolean).join(' ')}>
    <span>{children}</span>
    {variant === 'login' && <LoginIcon color="white" aria-hidden="true" />}
  </Link>
)
MobileNavigationAction.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(['insurance', 'login']).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
export default MobileNavigationAction
